/* import __COLOCATED_TEMPLATE__ from './transition-information.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();